import Button from "./Button";

export default class EnterHypoButton extends Button {
  setLeft: (this: EnterHypoButton) => void = () => {};
  setCenter: (this: EnterHypoButton) => void = () => {};
  setRight: (this: EnterHypoButton) => void = () => {};
}
